import { Injectable, Injector } from '@angular/core';
import { Credentials } from './credentials';
import { environment } from 'environments/environment';
import { JwtService } from 'core/services/jwt.service';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { HttpDataService } from 'core/services/http-data.service';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class AuthService extends HttpDataService {
  constructor(protected injector: Injector, public jwtService: JwtService) {
    super(injector, '/security');
  }

  // only used for local (not embedded) login
  public authenticate(credentials: Credentials): Promise<any> {
    return lastValueFrom(
      this.http.post<any>(this.baseUrl + '/auth/service/login', credentials, {
        ...this.getRequestOptions(),
        observe: 'response'
      })
    )
      .then((res: HttpResponse<any>) => {
        const ret = { valid: true, message: '' };
        if (res.status === 200) {
          const data = res.body;
          if (data && data.token) {
            this.jwtService.saveSessionToken(data.token);
            return ret;
          }
        }
        ret.valid = false;
        return ret;
      })
      .catch((error) => this.handlePromiseError(error));
  }

  public logout(): void {
    const token = this.jwtService.getSessionToken();
    const requestOptions = this.getRequestOptions();
    if (token) {
      requestOptions.headers.append('X-AUTH-TOKEN', token);
    }
    this.jwtService.destroyTokens();
    lastValueFrom(this.http.get(this.baseUrl + '/auth/logout', requestOptions))
      .then((res) => {
        const ret = { valid: true, message: res };
        return ret;
      })
      .catch((error) => this.handlePromiseError(error));
  }

  public requestApiKey(email?: string, clientId?: string): Promise<any> {
    const token = this.jwtService.getSessionToken();
    const headers = new HttpHeaders({
      // eslint-disable-next-line
      'Content-Type': 'application/json',
      // eslint-disable-next-line
      'x-auth-token': token
    });

    const requestOptions: any = {
      headers: headers
    };

    const requestBody: any = {
      sid: environment.SERVICE_ID,
      email,
      clientId
    };

    return lastValueFrom(this.http.post<any>(this.baseUrl + '/tokens/login', requestBody, requestOptions))
      .then((data: any) => {
        this.jwtService.saveApiKey(data.token);
        return data;
      })
      .catch((error) => {
        this.jwtService.destroyTokens();
        return this.handlePromiseError(error);
      });
  }

  public verifyToken(token: string): Promise<any> {
    const url = `${this.baseUrl}/auth/verifyToken/${token}`;
    return lastValueFrom(this.http.get<any>(url));
  }
}
